import React, { useContext } from 'react'

import clsx from 'clsx'

import { WappContext } from 'wapplr-react/dist/common/Wapp'

import Paper from 'karrierhub-ui/dist/common/src/components/Paper'
import Logo from 'karrierhub-ui/dist/common/src/components/Logo'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'
import Menu from 'karrierhub-ui/dist/common/src/components/Menu'

import AppContext from '../../../App/context'

export default function Footer(props) {

    const appContext = useContext(AppContext)
    const context = useContext(WappContext)

    const { wapp } = context

    const {
        classNames,
        footerChildren = [],
        footerSocialMenu = [],
        footerColTitles = [],
        footerSubtitle,
        footerCopyright,
        footerPaymentsImage,
        LogoProps = {},
        enableHeader = true,
        enableChildren = true,
        enableSocialMenu = true,
        enableFooter = true,
        enableCopyright = true,
        enableSubtitle = true,
        enablePayments = true,
        forceNarrow = false,
        PaperProps = {},
        CopyrightPaperProps = {},
        size
    } = props

    const footerMenu = [
        ...enableChildren && footerChildren?.length ? footerChildren : [],
        ...enableSocialMenu && footerSocialMenu?.length ? [{
            PaperProps: {
                className: classNames.footerSocialMenu
            },
            menu: footerSocialMenu
        }] : []
    ]

    return (
        <>
            <Paper
                color={'paper1'}
                borderRadius={0}
                size={'large'}
                container-type={'root-root'}
                {...PaperProps}
                className={clsx(
                    classNames.footer,
                    { [classNames.footerForceNarrow]: forceNarrow },
                    PaperProps.className
                )}
            >
                <div>
                    {enableHeader ?
                        <div className={classNames.footerHeader}>
                            <div className={classNames.footerLogo}>
                                <Logo
                                    ComponentProps={{
                                        href: '/',
                                        label: appContext.labels.logoAreaLabel
                                    }}
                                    long={true}
                                    classes={{
                                        root: classNames.footerLogoIconRoot
                                    }}
                                    {...LogoProps}
                                />
                            </div>
                        </div>
                        : null
                    }
                    {footerMenu && footerMenu.length ?
                        <div className={classNames.footerCols}>
                            {
                                footerMenu.map((menuProps = {}, key) => {

                                    return (
                                        <div
                                            className={classNames.footerCol}
                                            key={key}
                                        >
                                            {
                                                footerColTitles[key] ?
                                                    <Paper
                                                        className={classNames.footerColTitle}
                                                        color={'secondary'}
                                                        size={'none'}
                                                        variant={'text'}
                                                        elevation={0}
                                                    >
                                                        <Typography variant={'h6'}
                                                                    Component={'div'}>{footerColTitles[key]}</Typography>
                                                    </Paper>
                                                    : null
                                            }
                                            <Menu
                                                {...menuProps}
                                                PaperProps={{
                                                    ...menuProps.PaperProps ? menuProps.PaperProps : {},
                                                    color: 'secondary',
                                                    variant: 'text',
                                                    size: 'none',
                                                    elevation: 0,
                                                    borderRadius: 0
                                                }}
                                                MenuItemProps={{
                                                    size,
                                                    variant: 'text',
                                                    ...menuProps.MenuItemProps ? menuProps.MenuItemProps : {},
                                                    className: clsx(
                                                        classNames.footerMenuItem,
                                                        menuProps.MenuItemProps?.className
                                                    ),
                                                    classes: {
                                                        ...menuProps.MenuItemProps?.classes ? menuProps.MenuItemProps.classes : {},
                                                        label: clsx(
                                                            classNames.footerMenuItemLabel,
                                                            menuProps.MenuItemProps?.classes?.label
                                                        )
                                                    }
                                                }}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div> : null
                    }
                </div>
            </Paper>
            <Paper
                size={'small'}
                container-type={'root-root'}
                borderRadius={0}
                color={'gradient'}
                variant={'contained'}
                elevation={0}
                {...CopyrightPaperProps}
                className={clsx(
                    classNames.footer,
                    classNames.footerFooterContainer,
                    { [classNames.footerForceNarrow]: forceNarrow },
                    CopyrightPaperProps.className
                )}
            >
                <div>
                    {
                        enableFooter && (
                            (footerCopyright && enableCopyright) ||
                            (footerSubtitle && enableSubtitle) ||
                            (footerPaymentsImage && enablePayments)
                        ) ?
                            <div className={classNames.footerFooter}>
                                {enableSubtitle && footerSubtitle ?
                                    <Typography
                                        Component={'div'}
                                        letterSpacing={'0.03em'}
                                        fontSize={'0.75rem'}
                                        className={classNames.footerSubtitle}
                                    >
                                        {footerSubtitle}
                                    </Typography>
                                    : null
                                }
                                {
                                    enableCopyright && footerCopyright ?
                                        <div>
                                            <Typography
                                                Component={'div'}
                                                letterSpacing={'0.03em'}
                                                fontSize={'0.75rem'}
                                            >
                                                {footerCopyright}
                                            </Typography>
                                        </div> : null
                                }
                                {
                                    enablePayments && footerPaymentsImage ?
                                        <div className={classNames.footerPaymentsImage}>
                                            {footerPaymentsImage}
                                        </div> :
                                        null
                                }
                            </div> :
                            null
                    }
                </div>
            </Paper>
            <Typography
                Component={'div'}
                letterSpacing={'0.03em'}
                fontSize={'0.75rem'}
                weight={400}
                className={classNames.footerVer}
            >
                {'ver: ' + wapp.globals.WAPP}
            </Typography>
        </>
    )
}
